import { Components } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

type TooltipProps = Components<Omit<Theme, 'components'>>['MuiTooltip'];

const getMuiTooltip = (): TooltipProps => ({
  styleOverrides: {
    tooltip: ({ theme }: { theme: Theme }) => ({
      backgroundColor: theme.palette.semantic.ui.default,
      color: theme.palette.semantic.ui.content,
      maxWidth: 200,
      padding: '8px',
      // override MUI style: https://github.com/mui/material-ui/blob/v5.x/packages/mui-material/src/Tooltip/Tooltip.js#L128
      // While migrating to MUI v5, the tooltip changed from pxToRem(10) to pxToRem(11)
      // Unfortunately, we can't access `theme.typography.pxToRem` here. So we have to hardcode the calculated value.
      // pxToRem(10) = 0.714rem
      fontSize: '12px',
      lineHeight: '16.39px',
      fontWeight: 300,
    }),
    tooltipPlacementTop: {
      '@media (min-width: 0px)': {
        margin: '8px 0',
      },
    },
    arrow: ({ theme }: { theme: Theme }) => ({
      color: theme.palette.semantic.ui.default,
    }),
  },
  defaultProps: {
    placement: 'top',
    enterDelay: 250,
    enterNextDelay: 250,
  },
});
export default getMuiTooltip;
